import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Modal,
  Form,
  Table,
  Nav,
  Tab,
  InputGroup
} from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { firestore as db } from "../config/Config";
import { auth } from "../config/Config";
import { useSelector, useDispatch } from "react-redux";
import { fetchProjectList } from "../redux/projectReducer";
import { fetchAllCompletedProjectList, fetchCompletedProjectList } from "../redux/completedReducer";
import { createClients } from "../redux/createProject";

// import { completeClients } from "../redux/completedReducer";

function formatDisplayDate(dateVal) {
  if (!dateVal) return '-';
  if (typeof dateVal === 'string') {
    const trimmed = dateVal.trim();
    const ddmmyyyyMatch = trimmed.match(/^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})$/);
    if (ddmmyyyyMatch) {
      const day = ddmmyyyyMatch[1].padStart(2, '0');
      const month = ddmmyyyyMatch[2].padStart(2, '0');
      const year = ddmmyyyyMatch[3];
      return `${day}/${month}/${year}`;
    }
    const d = new Date(trimmed);
    if (!isNaN(d.getTime())) {
      return d.toLocaleDateString('en-GB');
    }
    return trimmed;
  }
  if (dateVal instanceof Date && !isNaN(dateVal.getTime())) {
    return dateVal.toLocaleDateString('en-GB');
  }
  const d = new Date(dateVal);
  return isNaN(d.getTime()) ? '-' : d.toLocaleDateString('en-GB');
}

export default function CompletedProjects() {
  const userDetailsLocal = localStorage.getItem('userDetails');
  const userDetailsLo = JSON.parse(userDetailsLocal);
  console.log("userDetails", userDetailsLocal);
  const [search, setSearch] = useState('');


  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [lim, setLim] = useState(10);

  const location = useLocation();
  const navigation = useNavigate();
  const dispatch = useDispatch();

  const { data, allCompletedData, status, loader, error } = useSelector((state) => state.completedProjects);
  console.log("porki", data);
  console.log("porki", allCompletedData);
  const { userData, userLoader, userError } = useSelector((state) => state.viewusers);
  console.log("checing user data ", userData);
  const userUID = localStorage.getItem('userUID');
  console.log("userUID ", userUID);
  useEffect(() => {
    dispatch(fetchProjectList({ userUID, page: currentPage, lim }));
  }, [currentPage, lim, dispatch]);

  useEffect(() => {
    auth.onAuthStateChanged(user => {
      const routeName = user !== null ? '/completed' : '/login';
      navigation(routeName);
    });
  }, [navigation]);

  useEffect(() => {
    dispatch(fetchCompletedProjectList({ userUID, page: currentPage, lim }));
    console.log("dashboard user data", userData);
  }, [dispatch, userUID]);

  useEffect(() => {
    dispatch(fetchAllCompletedProjectList({ userUID }));
    console.log("dashboard user data", userData);
  }, [dispatch, userUID]);



  const handleLogOut = () => {
    auth.signOut();
  };







  return (
    <Container fluid>
      <Row className='m-0' style={{
        // height: '100vh',
      }}  >
        <Col sm={1} >
          <Tab.Container  >
            <Row>
            </Row>
          </Tab.Container>
        </Col>



        <Col sm={11}>
          <Row style={{
            position: 'fixed',
            width: "90%",
          }}>
            <Col>
              <Col sm={10}  >


              </Col>
              <Col  >
              </Col>

              <Col
                sm={2}

              >



              </Col>


            </Col>
          </Row>
          <Row style={{
            // marginBottom: '50px',
            marginLeft: '0px',
            padding: '20px',
            borderRadius: '15px',
            boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
            backgroundColor: '#ffffff', // Light background color
            paddingTop: '50px',
            marginTop: '10vh',
          }}>

            <Row className="mt-5">
              <Col><p style={{ fontSize: '1em', fontWeight: '500', color: "#333", marginTop: "-70px" }}>COMPLETED PROJECTS</p></Col>
              <Col>
                <Form>
                  <InputGroup style={{
                    marginTop: "-70px", // Adjust the value as needed to move the input higher
                  }}>
                    <Form.Control onChange={(e) => setSearch(e.target.value)} placeholder="Search Projects" style={{
                      borderRadius: "15px", // More rounded corners
                      padding: "12px 15px", // Increased padding for better touch targets
                      border: "1px solid #d1d5db", // Lighter, modern border color
                      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)", // Slightly larger shadow for depth
                      background: "linear-gradient(145deg, #ffffff, #f3f4f6)", // Subtle gradient background
                      transition: "all 0.3s ease",
                    }}
                      onFocus={(e) => {
                        e.target.style.borderColor = "#5a67d8"; // Change border color on focus
                        e.target.style.boxShadow = "0 4px 12px rgba(90, 103, 216, 0.3)"; // Blue shadow on focus
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = "#d1d5db"; // Reset border color on blur
                        e.target.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.1)"; // Reset shadow on blur
                      }} />
                  </InputGroup>
                </Form>
              </Col>

              {/* <div className="table-container">
                {status === "loading" ? (
                  <div className="loader">Loading...</div>
                ) : status === "failed" ? (
                  <p className="text-danger">{error}</p>
                ) : status === "succeeded" && data.clients && data.clients.length > 0 ? (
                  <div className="tableScroll">
                    <table>
                      <thead>
                        <tr>
                          <th>Project</th>
                          <th>Name</th>
                          <th>Number</th>
                          <th>Create</th>
                          <th>Status</th>
                          <th>Created By</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody className="hover-content">
                        {data.clients
                          .filter((item) =>
                            search.toLowerCase() === ""
                              ? item
                              : item.pname.toLowerCase().includes(search)
                          )
                          .map((e) => (
                            <tr key={e.ID}>
                              <td>{e.pname}</td>
                              <td>{e.cname}</td>
                              <td>{e.cphone}</td>
                              <td>{e.date}</td>
                              <td>{e.status}</td>
                              <td>{e.createdBy}</td>
                              <td>
                                <button
                                  className="buttonDesign"
                                  onClick={() =>
                                    navigation("/projects/completed-rooms", { state: e })
                                  }
                                >
                                  View Rooms
                                </button>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="noDataFound">No projects found.</div>
                )}
              </div> */}
              <div className="table-container">
                <div className="tableScroll">
                  <table>
                    <thead>
                      <tr>
                        <th>Project</th>
                        <th>Name</th>
                        <th>Number</th>
                        <th>Create</th>
                        <th>Status</th>
                        <th>Created By</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody className="hover-content">
                      {(search.toLowerCase() === ""
                        ? data?.clients || []
                        : data?.clients?.filter((item) => {
                          const searchQuery = search.toLowerCase();
                          return (
                            (item.pname?.toLowerCase().includes(searchQuery) || '') ||
                            (item.cname?.toLowerCase().includes(searchQuery) || '') ||
                            (item.cphone ? String(item.cphone).toLowerCase().includes(searchQuery) : false)
                          );
                        })
                      )?.map((e) => (
                        <tr key={e.ID}>
                          <td>{e.pname}</td>
                          <td>{e.cname}</td>
                          <td>{e.cphone}</td>
                          <td>{formatDisplayDate(e.date || e.dateTimec || e.timestamp)}</td>
                          <td>{e.status}</td>
                          <td>{e.createdBy}</td>
                          <td>
                            <button
                              className="buttonDesign"
                              onClick={() => navigation("/completed/completed-rooms", { state: e })}
                            >
                              View Rooms
                            </button>
                          </td>
                        </tr>
                      ))}

                      {/* If no matching data after search */}
                      {data?.clients?.length === 0 && (
                        <tr>
                          <td colSpan="7" className="noDataFound">No projects found.</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>



              {/* Pagination controls */}
              <Row style={{
                marginTop: '1vh',
              }} >
                <Col sm={1}>
                </Col>
                <Col sm={11}>
                  <hr />
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '1rem'
                  }} >
                    <button className="buttonDesign" onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1}>
                      Previous
                    </button>
                    <span >Page {currentPage}</span>
                    <button className="buttonDesign" onClick={() => setCurrentPage(prev => prev + 1)} disabled={!data.hasNextPage}>
                      Next
                    </button>
                  </div>
                </Col>
              </Row>



            </Row>
          </Row>

        </Col>
      </Row>
    </Container>
  );
}
